export default "__VITE_ASSET__B_FKQ3IA__"